<template>
    <v-container fluid class="pa-0">
        <template v-if="loadingProject">
            <banner/>
        </template>
        <template v-else>
            <banner 
                :title="project.title"
                :description="project.shortDescription"
                :backUrl="`/${$i18n.locale}/ecreative/open/projects`"
            />
            <v-container>
                <v-row justify="center" class="px-4">
                    <v-col cols="12" md="6">
                        <div class="d-flex flex-column flex-md-row justify-center">
                            <v-chip 
                                outlined 
                                color="primary" 
                                class="ma-2"
                            >
                                <span class="subtitle-2">{{ $t('Topic') }}: {{ getTopicById(project.topicId) }}</span>
                            </v-chip>
                            <v-chip 
                                outlined 
                                color="primary" 
                                class="ma-2"
                            >
                                <v-icon left>mdi-calendar</v-icon> 
                                <span class="subtitle-2" v-if="!isBidingDeadlineOver">
                                    {{ $t('BidingEndsBy') }}: {{ projectBidingDeadline }}
                                </span>
                                <span class="subtitle-2" v-else>
                                    {{ $t('VotingEndsBy') }}: {{ projectVotingDeadline }}
                                </span>
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
                <div class="d-flex align-center justify-center">
                    <div class="d-flex justify-space-between">
                        <div class="text-center title mx-3">
                            <img src="@/assets/images/medal-gold.svg" class="medal-icon" alt="">
                            <div>{{ $t('1stPlace') }} ${{ project.firstPlacePrice }}</div>
                        </div>
                        <div class="text-center title mx-3">
                            <img src="@/assets/images/medal-silver.svg" class="medal-icon" alt="">
                            <div>{{ $t('2ndPlace') }} ${{ project.secondPlacePrice }}</div>
                        </div>
                        <div class="text-center title mx-3">
                            <img src="@/assets/images/medal-bronze.svg" class="medal-icon" alt="">
                            <div>{{ $t('3rdPlace') }} ${{ project.thirdPlacePrice }}</div>
                        </div>
                    </div>
                </div>
            </v-container>
        </template>
        <template v-if="loadingBids">
            <div class="text-center">
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </div>
        </template>
        <template v-else>
            <v-container>                
                <template v-if="bids.length > 0">
                    <v-row justify="center" class="px-4 mt-2 mt-lg-4">
                        <v-col 
                            cols="12" 
                            md="6" 
                            lg="3"
                            v-for="(bid, index) in bids"
                            :key="index"
                        >
                            <bid-card :bid="bid.bid" :hasVotingEnded="hasVotingEnded"/>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <div class="headline my-4 my-lg-10 text-center" v-text="$t('NoRecords')"></div>
                </template>
            </v-container>
        </template>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner'
    import BidCard from '@/components/bidCard'

    export default {
        name: 'ecreativeProjectBids',
        data: () => ({
            projectId: null,
            project: {},
            bids: [],
            topics: [],
            snackbar: {
                show: true,
                message: ''
            },
            hasVotingEnded: false,
            loadingBids: true,
            loadingProject: true
        }),
        components: {
            Banner,
            BidCard
        },
        computed: {
            ...mapGetters(['user', 'preferedLanguage']),
            projectBidingDeadline() {
                if(this.project.bidDeadline) {
                    return moment(this.project.bidDeadline).format('MM/DD/YYYY')
                }
                return null
            },
            projectVotingDeadline() {
                if(this.project.votingDeadline) {
                    return moment(this.project.votingDeadline.localTime).format('MM/DD/YYYY')
                }
                return null
            },
            isBidingDeadlineOver() {
                return moment(this.project.bidDeadline).isBefore(new Date())
            }
        },
        beforeMount() {
            this.projectId = this.$route.params.id
        },
        mounted() {
            this.fetchProject()
            this.fetchBids()
            this.fetchTopics()
        },
        methods: {
            async fetchProject() {
                this.axios.get('/Project/GetProject', {
                    params: {
                        id: this.projectId,
                        languageId: this.preferedLanguage
                    }
                })
                .then(response => {
                    this.project = response.data.project
                    this.projectFiles = response.data.projectFiles
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loadingProject = false
            },
            async fetchBids() {
                await this.axios.get('/ProjectBid/GetAvaliableBids', {
                    params: {
                        projectId: this.projectId,
                        userId: this.user.id,
                        languageId: this.preferedLanguage
                    }
                })
                .then(response => {
                    this.hasVotingEnded = response.data.hasVotingEnded
                    this.bids = response.data.list
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                this.loadingBids = false
            },
            fetchTopics() {
                this.axios.get('/Topic/GetAllTopics', {
                    params: {
                        languageId: this.preferedLanguage
                    }
                })
                .then(response => {
                    this.topics = response.data
                })
            },
            getTopicById(id) {
                return this.topics.filter(topic => topic.id == id).map(topic => topic.name)[0]
            }
        }
    }
</script>

<style lang="scss" scoped>
.medal-icon{
    width: 40px;
}
</style>